import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { withProfiler } from '@sentry/react'
import { CookiesProvider } from 'react-cookie'
import { SnackbarProvider } from 'notistack'
import { MotionConfig } from 'framer-motion'

import 'i18n/i18n'

import { Router } from 'router/Router'

import { GlobalContextWrapper } from 'context'
import { GlobalStyles } from 'styles'

import { MuiThemeWrapper } from 'common/theme'

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } }
})

const App: React.FC = () => {
  return (
    <React.StrictMode>
      <CookiesProvider>
        <QueryClientProvider client={queryClient}>
          <SnackbarProvider
            style={{ marginBottom: '0.5rem', marginRight: '7rem' }}
            maxSnack={5}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            autoHideDuration={3000}
          >
            <MotionConfig
              transition={{ type: 'spring', bounce: 3, damping: 4 }}
            >
              <GlobalContextWrapper>
                <MuiThemeWrapper>
                  <>
                    <GlobalStyles />
                    <Router />
                  </>
                </MuiThemeWrapper>
              </GlobalContextWrapper>
            </MotionConfig>
          </SnackbarProvider>
        </QueryClientProvider>
      </CookiesProvider>
    </React.StrictMode>
  )
}

export default withProfiler(App)
